































































































































import { Component, Vue } from 'vue-property-decorator'
import { VeeValidateObserverRef } from '@/models/Common/Validation'
import AuthService from '@/services/AuthService'
import { getModule } from 'vuex-module-decorators'
import Auth from '@/store/modules/Auth'
import store from '@/store'
import i18n from '@/lang'

const AuthModule = getModule(Auth, store)

@Component
export default class UpdatePassword extends Vue {
  $refs!: {
    observer: VeeValidateObserverRef
  }
  errorConfirmPassword: boolean = false
  new_password: string = ''
  confirm_new_password: string = ''
  isLoading: boolean = false
  isCompleted: boolean = false
  showErrorMsg: boolean = false

  beforeRouteEnter(_: any, __: any, next: any) {
    const shouldUpdatePassword = store.state.auth.shouldUpdatePassword

    if (!shouldUpdatePassword) {
      next({ name: 'home' })
      return
    }

    next()
  }

  handleLogoutRequest() {
    AuthModule.SET_TOKEN_NULL()
    i18n.locale = 'ja'
    sessionStorage.clear()
    localStorage.clear()
  }

  async logout() {
    const params = {
      token: sessionStorage.getItem('device_token')
    }

    if (params.token) {
      await AuthService.resetTotalNotification(params)
      await AuthService.logout(params)
      this.handleLogoutRequest()
    } else {
      await AuthService.logout(params)
      this.handleLogoutRequest()
    }
  }

  updatePassword() {
    this.$refs.observer.validate().then(async isValidate => {
      if (isValidate) {
        if (this.new_password !== this.confirm_new_password) {
          this.errorConfirmPassword = true
        } else {
          this.isLoading = true
          const data = {
            password: this.new_password,
            password_confirmation: this.confirm_new_password
          }

          try {
            await AuthService.updateOldPassword(data)
            await this.logout()
            this.showErrorMsg = false
            this.isCompleted = true
          } catch {
            this.showErrorMsg = true
          } finally {
            this.isLoading = false
            this.errorConfirmPassword = false
          }
        }
      } else {
        return null
      }
    })
  }

  resetMsg() {
    this.showErrorMsg = false
    this.errorConfirmPassword = false
  }

  goToLogin() {
    this.$router.push({ name: 'login' })
  }
}
